module.exports = __webpack_public_path__ + "static/media/shirley.5c76e435.png";